import Dbm from "dbm";

export default class KeyboardController extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        this.item.requireProperty("gamePlay", null);
        this.item.requireProperty("player", null);

        this._callback_keyDownBound = this._callback_keyDown.bind(this);
        this._callback_keyUpBound = this._callback_keyUp.bind(this);

        this.item.requireProperty("active", false).addUpdate(this._getScopedCallFunctionCommand(this._activeChanged));
    }

    _activeChanged() {
        if(this.item.active) {
            this._activate();
        }
        else {
            this._deactivate();
        }
    }

    _activate() {
        //console.log("_activate");

        window.addEventListener("keydown", this._callback_keyDownBound);
        window.addEventListener("keyup", this._callback_keyUpBound);
    }

    _deactivate() {
        //console.log("_deactivate");

        window.removeEventListener("keydown", this._callback_keyDownBound);
        window.removeEventListener("keyup", this._callback_keyUpBound);
    }

    _callback_keyDown(aEvent) {
        //console.log("_callback_keyDown");

        if (aEvent.code === "Space") {
            this.item.player.controller.startJump();

            aEvent.stopImmediatePropagation();
            aEvent.preventDefault();
            
        }

        if (aEvent.code === "ShiftLeft" || aEvent.code === "ShiftRight" || aEvent.code === "Enter") {
            this.item.player.controller.throw();

            aEvent.stopImmediatePropagation();
            aEvent.preventDefault();
        }
    }

    _callback_keyUp(aEvent) {
        //console.log("_callback_keyUp");

        if(aEvent.code === "Space") {
            this.item.player.controller.jumpReleased();
        }
    }
}